import styles from "./styles/style.module.scss";

const TextArea = ({
  label,
  type,
  placeholder,
  value,
  name,
  onChangeHandler,
  error
}) => {
  return (
    <div className={styles.inputDiv}>
      <label className={styles.inputLabel}>{label}</label>
      <textarea
        style={{ borderColor: error ? "red" : "" }}
        type={type}
        placeholder={placeholder}
        value={value}
        name={name}
        onChange={onChangeHandler}
      />
      {error && (
        <span  style={{ color: "red", fontSize: "12px" }}> * Required</span>
      )}
    </div>
  );
};

export default TextArea;
